import React, { useContext, useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useFetchRequestAccessForm } from './api/hooks/useFetchRequestAccessForm';
import { RequestAccessFormContext } from './contexts/request-access-form-context';
import LandingPage from './components/landing-page';
import ConnectAccount from './components/connect-account';
import SelectAccount from './components/select-account';
import AccessGranted from './components/access-granted';
import { applyTheme } from './utils/applyTheme';
import Loader from './components/loader/loader';
import { useGoogleConnectQueryParams } from './components/hooks/useGoogleConnectQueryParams';

const App = () => {
    const { step } = useContext(RequestAccessFormContext);
    const { i18n } = useTranslation();
    const { accessId } = useParams();
    const { isError: isGoogleConnectError } = useGoogleConnectQueryParams();
    const {
        data,
        translations,
        error: isInitialRequestError,
        isErrorAccessIdNotFound,
        isLoading,
    } = useFetchRequestAccessForm();

    useEffect(() => {
        if (translations && data?.language) {
            i18n.addResourceBundle(data.language, 'translation', translations, true, true);
            i18n.changeLanguage(data.language);
        }
    }, [translations, i18n, data?.language]);

    useEffect(() => {
        if (data) {
            applyTheme(data);
        }
    }, [data]);

    if (isLoading) return <Loader />;
    if (isErrorAccessIdNotFound) return <Navigate to="/not-found" replace={true} />;
    if (isInitialRequestError || isGoogleConnectError)
        return <Navigate to={`/${accessId}/error`} replace={true} />;

    switch (step) {
        case 0:
            return <LandingPage />;
        case 1:
            return <ConnectAccount />;
        case 2:
            return <SelectAccount />;
        case 3:
            return <AccessGranted />;
        default:
            return <LandingPage />;
    }
};

export default App;
